exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".playingContainer[data-v-728fc216]{height:1000px;display:flex;flex-wrap:wrap}.left[data-v-728fc216]{height:500px;width:800px}.right h2[data-v-728fc216]{color:#d3d3d3;font-weight:700;padding:5px}.right[data-v-728fc216]{width:400px;height:460px;margin-top:40px;overflow-y:auto}.videoSuggestionItem[data-v-728fc216]:hover{cursor:pointer}.videoSuggestionItem[data-v-728fc216]{width:100%;height:100px;display:flex;margin-top:5px;padding:10px}.videoSuggestionItemImage[data-v-728fc216]{width:100px;height:100%;display:flex;align-items:center;justify-content:center;text-align:center;color:#fff;font-size:25px}.videoSuggestionItem .text[data-v-728fc216]{display:flex;align-items:center;justify-content:center;text-align:center;width:80%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-728fc216","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/app/videos_insanity/playing.vue
// module id = 634
// module chunks = 0